import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Button, Stack} from '@mui/material';

import {AlertModal} from 'presentation/components';
import {HomeEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {RequestErrorModalProps} from './types';

const {headerTitle, description, primaryAction, secondaryAction, title} =
	translations['pt-br'].privateFlow.refund.requestErrorModal;

export const RequestErrorModal = ({open, setOpen}: RequestErrorModalProps) => {
	const navigate = useNavigate();
	const {isMobile} = useMediaQueries();

	function handleGoToHome() {
		navigate(HomeEnum.HOME_PAGE);
		setOpen(prev => !prev);
	}

	return (
		<AlertModal
			open={open}
			onClose={() => setOpen(prev => !prev)}
			variant="info"
			title={title}
			headerDataTagId={RefundTaggingEnum.ERRO_AO_PROSSEGUIR_COM_SOLICITACAO_REEMBOLSO}
			headerTitle={headerTitle}
			description={description}
		slotProps={{
			paper: {
				style: {
					maxWidth: 420,
					margin: isMobile ? 16 : 'auto',
					flex: isMobile ? 1 : 'initial',
				},
			},
		}}
			footerContent={
				<Stack gap={1} sx={{width: '100%'}}>
					<Button fullWidth size="large" variant="outlined" onClick={handleGoToHome}>
						{secondaryAction}
					</Button>
					<Button
						fullWidth
						size="large"
						variant="contained"
						onClick={() => setOpen(prev => !prev)}>
						{primaryAction}
					</Button>
				</Stack>
			}
		/>
	);
};
